import { Product } from '@axo/shared/data-access/types';
import { ApplicantDataApplicantTabPanelLayout } from './ApplicationDataApplicantTabPanelLayout';
import { DebtSection } from './Sections/DebtSection';
import { DocumentsSection } from './Sections/DocumentsSection';
import { FinanceSection } from './Sections/FinanceSection';
import { HouseholdSection } from './Sections/HouseholdSection';
import { PersonalSection } from './Sections/PersonalSection';
import { ApplicationConditionalWrapper } from '../../ConditionalWrappers/ApplicationConditionalWrapper';
import { ConsumptionSection } from './Sections/ConsumptionSection';
import styles from './ApplicationDataMainApplicantTabPanel.module.css';
import { MarketCountryCode } from '@axo/shared/types';

interface ApplicationDataMainApplicantTabPanelProps {
  applicationID: string;
}

export const ApplicationDataMainApplicantTabPanel: React.FC<
  ApplicationDataMainApplicantTabPanelProps
> = ({ applicationID }) => {
  return (
    <ApplicantDataApplicantTabPanelLayout>
      <ApplicationConditionalWrapper
        whitelist={[
          { productType: [Product.UnsecuredLoan, Product.CreditCard] },
        ]}
      >
        <div className={styles.verticalStack}>
          <PersonalSection
            applicationID={applicationID}
            coApplicantCustomerID={undefined}
            coApplicantPersonID={undefined}
          />
          <ApplicationConditionalWrapper
            whitelist={[
              {
                marketCountry: [MarketCountryCode.Denmark],
              },
            ]}
          >
            <ConsumptionSection applicationID={applicationID} />
          </ApplicationConditionalWrapper>
        </div>
      </ApplicationConditionalWrapper>
      <FinanceSection
        applicationID={applicationID}
        coApplicantCustomerID={undefined}
        coApplicantPersonID={undefined}
      />
      <HouseholdSection
        applicationID={applicationID}
        coApplicantCustomerID={undefined}
        coApplicantPersonID={undefined}
      />
      <DebtSection
        applicationID={applicationID}
        coApplicantCustomerID={undefined}
        coApplicantPersonID={undefined}
      />
      <ApplicationConditionalWrapper
        whitelist={[{ productType: [Product.SecuredLoan] }]}
      >
        <DocumentsSection
          applicationID={applicationID}
          coApplicantCustomerID={undefined}
          coApplicantPersonID={undefined}
        />
      </ApplicationConditionalWrapper>
    </ApplicantDataApplicantTabPanelLayout>
  );
};
